<template>
    <v-app class="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">创建团队</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:3rem;">
                <div style="width:90%;margin:auto;text-align:center;margin-top:5rem;">
                    <!-- <div style="font-size:1.4rem;">输入企业、组织或团队的名字</div> -->
                    <div style="font-size:1.4rem;">输入个人团队的名字</div>
                    <div style="margin-top:1rem;">
                        <v-text-field v-model="companyName" @change="changeName"></v-text-field>
                    </div>
                    <div style="margin-top:1rem;">
                        <v-btn large color="success" style="width:80%;" :loading="submitLoading" :disabled="submitLoading" @click="submit">完成创建</v-btn>
                    </div>
                    <div style="margin-top:1rem;font-size:0.75rem;color:#9e9e9e;">最多只能创建一个</div>
                </div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      companyName: '',
      btnDisabled: true,
      submitLoading: false
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goBack: function() {
      var that = this;
      that.$router.goBack()
    },
    changeName() {
      var that = this
      that.btnDisabled = that.companyName === ''
    },
    submit() {
      var that = this
      if (!that.companyName) {
        that.$toast.warning('名字不能为空')
        return
      }
      var company = {
        company_name: that.companyName
      }
      that.submitLoading = true
      that.$api.bz.createCompany({ str_company: JSON.stringify(company) }).then(res => {
        that.submitLoading = false
        console.log('生成企业邀请码', res)
        if (!res.success) {
          that.$toast.error(res.error_msg ? res.error_msg : '创建失败')
          // that.$router.goActionResPage({ tag: 0, text: '创建失败', auto_ret: 'b' });
          return
        }
        that.$router.goActionResPage({ tag: 1, text: '创建成功', auto_ret: 'y', dest: -2, refresh: true });
      })
    }
  }
}
</script>

<style scoped>
</style>
